/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createSession = /* GraphQL */ `
  mutation CreateSession(
    $input: CreateSessionInput!
    $condition: ModelSessionConditionInput
  ) {
    createSession(input: $input, condition: $condition) {
      id
      questions
      initTime
      subquestionsOrder
      weCount
      createdAt
      updatedAt
    }
  }
`;
export const updateSession = /* GraphQL */ `
  mutation UpdateSession(
    $input: UpdateSessionInput!
    $condition: ModelSessionConditionInput
  ) {
    updateSession(input: $input, condition: $condition) {
      id
      questions
      initTime
      subquestionsOrder
      weCount
      createdAt
      updatedAt
    }
  }
`;
export const deleteSession = /* GraphQL */ `
  mutation DeleteSession(
    $input: DeleteSessionInput!
    $condition: ModelSessionConditionInput
  ) {
    deleteSession(input: $input, condition: $condition) {
      id
      questions
      initTime
      subquestionsOrder
      weCount
      createdAt
      updatedAt
    }
  }
`;
export const createNetworkQualityLog = /* GraphQL */ `
  mutation CreateNetworkQualityLog(
    $input: CreateNetworkQualityLogInput!
    $condition: ModelNetworkQualityLogConditionInput
  ) {
    createNetworkQualityLog(input: $input, condition: $condition) {
      timestamp
      username
      sessionId
      description
      createdAt
      updatedAt
      id
    }
  }
`;
export const updateNetworkQualityLog = /* GraphQL */ `
  mutation UpdateNetworkQualityLog(
    $input: UpdateNetworkQualityLogInput!
    $condition: ModelNetworkQualityLogConditionInput
  ) {
    updateNetworkQualityLog(input: $input, condition: $condition) {
      timestamp
      username
      sessionId
      description
      createdAt
      updatedAt
      id
    }
  }
`;
export const deleteNetworkQualityLog = /* GraphQL */ `
  mutation DeleteNetworkQualityLog(
    $input: DeleteNetworkQualityLogInput!
    $condition: ModelNetworkQualityLogConditionInput
  ) {
    deleteNetworkQualityLog(input: $input, condition: $condition) {
      timestamp
      username
      sessionId
      description
      createdAt
      updatedAt
      id
    }
  }
`;
export const createInterview = /* GraphQL */ `
  mutation CreateInterview(
    $input: CreateInterviewInput!
    $condition: ModelInterviewConditionInput
  ) {
    createInterview(input: $input, condition: $condition) {
      id
      group
      questions
      interviewInfo
      scheduling
      stage
      companyID
      companyName
      interviewResultData
      questionResponses {
        nextToken
      }
      recordings {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateInterview = /* GraphQL */ `
  mutation UpdateInterview(
    $input: UpdateInterviewInput!
    $condition: ModelInterviewConditionInput
  ) {
    updateInterview(input: $input, condition: $condition) {
      id
      group
      questions
      interviewInfo
      scheduling
      stage
      companyID
      companyName
      interviewResultData
      questionResponses {
        nextToken
      }
      recordings {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteInterview = /* GraphQL */ `
  mutation DeleteInterview(
    $input: DeleteInterviewInput!
    $condition: ModelInterviewConditionInput
  ) {
    deleteInterview(input: $input, condition: $condition) {
      id
      group
      questions
      interviewInfo
      scheduling
      stage
      companyID
      companyName
      interviewResultData
      questionResponses {
        nextToken
      }
      recordings {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createCompany = /* GraphQL */ `
  mutation CreateCompany(
    $input: CreateCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    createCompany(input: $input, condition: $condition) {
      id
      group
      email
      firstName
      lastName
      company
      users {
        nextToken
      }
      roles {
        nextToken
      }
      interviews {
        nextToken
      }
      interviewInfo
      discovery
      values1
      values2
      plan
      stripeCustomerId
      status
      hasLoggedIn
      displayOrder
      interviewBuilderData
      createdAt
      updatedAt
    }
  }
`;
export const updateCompany = /* GraphQL */ `
  mutation UpdateCompany(
    $input: UpdateCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    updateCompany(input: $input, condition: $condition) {
      id
      group
      email
      firstName
      lastName
      company
      users {
        nextToken
      }
      roles {
        nextToken
      }
      interviews {
        nextToken
      }
      interviewInfo
      discovery
      values1
      values2
      plan
      stripeCustomerId
      status
      hasLoggedIn
      displayOrder
      interviewBuilderData
      createdAt
      updatedAt
    }
  }
`;
export const deleteCompany = /* GraphQL */ `
  mutation DeleteCompany(
    $input: DeleteCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    deleteCompany(input: $input, condition: $condition) {
      id
      group
      email
      firstName
      lastName
      company
      users {
        nextToken
      }
      roles {
        nextToken
      }
      interviews {
        nextToken
      }
      interviewInfo
      discovery
      values1
      values2
      plan
      stripeCustomerId
      status
      hasLoggedIn
      displayOrder
      interviewBuilderData
      createdAt
      updatedAt
    }
  }
`;
export const createCompanyExamples = /* GraphQL */ `
  mutation CreateCompanyExamples(
    $input: CreateCompanyExamplesInput!
    $condition: ModelCompanyExamplesConditionInput
  ) {
    createCompanyExamples(input: $input, condition: $condition) {
      id
      companyID
      attributeId
      score
      text
      createdAt
      updatedAt
    }
  }
`;
export const updateCompanyExamples = /* GraphQL */ `
  mutation UpdateCompanyExamples(
    $input: UpdateCompanyExamplesInput!
    $condition: ModelCompanyExamplesConditionInput
  ) {
    updateCompanyExamples(input: $input, condition: $condition) {
      id
      companyID
      attributeId
      score
      text
      createdAt
      updatedAt
    }
  }
`;
export const deleteCompanyExamples = /* GraphQL */ `
  mutation DeleteCompanyExamples(
    $input: DeleteCompanyExamplesInput!
    $condition: ModelCompanyExamplesConditionInput
  ) {
    deleteCompanyExamples(input: $input, condition: $condition) {
      id
      companyID
      attributeId
      score
      text
      createdAt
      updatedAt
    }
  }
`;
export const createCompanyInterviewDefaults = /* GraphQL */ `
  mutation CreateCompanyInterviewDefaults(
    $input: CreateCompanyInterviewDefaultsInput!
    $condition: ModelCompanyInterviewDefaultsConditionInput
  ) {
    createCompanyInterviewDefaults(input: $input, condition: $condition) {
      id
      companyId
      email
      name
      stage
      userId
      createdAt
      updatedAt
    }
  }
`;
export const updateCompanyInterviewDefaults = /* GraphQL */ `
  mutation UpdateCompanyInterviewDefaults(
    $input: UpdateCompanyInterviewDefaultsInput!
    $condition: ModelCompanyInterviewDefaultsConditionInput
  ) {
    updateCompanyInterviewDefaults(input: $input, condition: $condition) {
      id
      companyId
      email
      name
      stage
      userId
      createdAt
      updatedAt
    }
  }
`;
export const deleteCompanyInterviewDefaults = /* GraphQL */ `
  mutation DeleteCompanyInterviewDefaults(
    $input: DeleteCompanyInterviewDefaultsInput!
    $condition: ModelCompanyInterviewDefaultsConditionInput
  ) {
    deleteCompanyInterviewDefaults(input: $input, condition: $condition) {
      id
      companyId
      email
      name
      stage
      userId
      createdAt
      updatedAt
    }
  }
`;
export const createClientAndIndustry = /* GraphQL */ `
  mutation CreateClientAndIndustry(
    $input: CreateClientAndIndustryInput!
    $condition: ModelClientAndIndustryConditionInput
  ) {
    createClientAndIndustry(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
export const updateClientAndIndustry = /* GraphQL */ `
  mutation UpdateClientAndIndustry(
    $input: UpdateClientAndIndustryInput!
    $condition: ModelClientAndIndustryConditionInput
  ) {
    updateClientAndIndustry(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
export const deleteClientAndIndustry = /* GraphQL */ `
  mutation DeleteClientAndIndustry(
    $input: DeleteClientAndIndustryInput!
    $condition: ModelClientAndIndustryConditionInput
  ) {
    deleteClientAndIndustry(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
export const createCompanyValues = /* GraphQL */ `
  mutation CreateCompanyValues(
    $input: CreateCompanyValuesInput!
    $condition: ModelCompanyValuesConditionInput
  ) {
    createCompanyValues(input: $input, condition: $condition) {
      id
      companyID
      title
      description
      weight
      weightedAttributes
      createdAt
      updatedAt
    }
  }
`;
export const updateCompanyValues = /* GraphQL */ `
  mutation UpdateCompanyValues(
    $input: UpdateCompanyValuesInput!
    $condition: ModelCompanyValuesConditionInput
  ) {
    updateCompanyValues(input: $input, condition: $condition) {
      id
      companyID
      title
      description
      weight
      weightedAttributes
      createdAt
      updatedAt
    }
  }
`;
export const deleteCompanyValues = /* GraphQL */ `
  mutation DeleteCompanyValues(
    $input: DeleteCompanyValuesInput!
    $condition: ModelCompanyValuesConditionInput
  ) {
    deleteCompanyValues(input: $input, condition: $condition) {
      id
      companyID
      title
      description
      weight
      weightedAttributes
      createdAt
      updatedAt
    }
  }
`;
export const createSubscriptionProduct = /* GraphQL */ `
  mutation CreateSubscriptionProduct(
    $input: CreateSubscriptionProductInput!
    $condition: ModelSubscriptionProductConditionInput
  ) {
    createSubscriptionProduct(input: $input, condition: $condition) {
      id
      product_id
      cost
      currency
      interval
      intervalCount
      metaDescription
      metaLabel
      price_id
      taxBehavior
      createdAt
      updatedAt
    }
  }
`;
export const updateSubscriptionProduct = /* GraphQL */ `
  mutation UpdateSubscriptionProduct(
    $input: UpdateSubscriptionProductInput!
    $condition: ModelSubscriptionProductConditionInput
  ) {
    updateSubscriptionProduct(input: $input, condition: $condition) {
      id
      product_id
      cost
      currency
      interval
      intervalCount
      metaDescription
      metaLabel
      price_id
      taxBehavior
      createdAt
      updatedAt
    }
  }
`;
export const deleteSubscriptionProduct = /* GraphQL */ `
  mutation DeleteSubscriptionProduct(
    $input: DeleteSubscriptionProductInput!
    $condition: ModelSubscriptionProductConditionInput
  ) {
    deleteSubscriptionProduct(input: $input, condition: $condition) {
      id
      product_id
      cost
      currency
      interval
      intervalCount
      metaDescription
      metaLabel
      price_id
      taxBehavior
      createdAt
      updatedAt
    }
  }
`;
export const createAttribute = /* GraphQL */ `
  mutation CreateAttribute(
    $input: CreateAttributeInput!
    $condition: ModelAttributeConditionInput
  ) {
    createAttribute(input: $input, condition: $condition) {
      id
      companyID
      group
      title
      description
      weight
      questions {
        nextToken
      }
      examples {
        text
        score
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateAttribute = /* GraphQL */ `
  mutation UpdateAttribute(
    $input: UpdateAttributeInput!
    $condition: ModelAttributeConditionInput
  ) {
    updateAttribute(input: $input, condition: $condition) {
      id
      companyID
      group
      title
      description
      weight
      questions {
        nextToken
      }
      examples {
        text
        score
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteAttribute = /* GraphQL */ `
  mutation DeleteAttribute(
    $input: DeleteAttributeInput!
    $condition: ModelAttributeConditionInput
  ) {
    deleteAttribute(input: $input, condition: $condition) {
      id
      companyID
      group
      title
      description
      weight
      questions {
        nextToken
      }
      examples {
        text
        score
      }
      createdAt
      updatedAt
    }
  }
`;
export const createValue = /* GraphQL */ `
  mutation CreateValue(
    $input: CreateValueInput!
    $condition: ModelValueConditionInput
  ) {
    createValue(input: $input, condition: $condition) {
      id
      group
      name
      description
      organizationID
      companyId
      behaviors {
        nextToken
      }
      weight
      status
      createdAt
      updatedAt
    }
  }
`;
export const updateValue = /* GraphQL */ `
  mutation UpdateValue(
    $input: UpdateValueInput!
    $condition: ModelValueConditionInput
  ) {
    updateValue(input: $input, condition: $condition) {
      id
      group
      name
      description
      organizationID
      companyId
      behaviors {
        nextToken
      }
      weight
      status
      createdAt
      updatedAt
    }
  }
`;
export const deleteValue = /* GraphQL */ `
  mutation DeleteValue(
    $input: DeleteValueInput!
    $condition: ModelValueConditionInput
  ) {
    deleteValue(input: $input, condition: $condition) {
      id
      group
      name
      description
      organizationID
      companyId
      behaviors {
        nextToken
      }
      weight
      status
      createdAt
      updatedAt
    }
  }
`;
export const createValueAttribute = /* GraphQL */ `
  mutation CreateValueAttribute(
    $input: CreateValueAttributeInput!
    $condition: ModelValueAttributeConditionInput
  ) {
    createValueAttribute(input: $input, condition: $condition) {
      id
      attributeId
      valueId
      value {
        id
        group
        name
        description
        organizationID
        companyId
        weight
        status
        createdAt
        updatedAt
      }
      companyId
      group
      attribute {
        id
        name
        definition
        stage
        customerDefinition
        align
        nonAlign
        createdAt
        updatedAt
      }
      weight
      order
      createdAt
      updatedAt
    }
  }
`;
export const updateValueAttribute = /* GraphQL */ `
  mutation UpdateValueAttribute(
    $input: UpdateValueAttributeInput!
    $condition: ModelValueAttributeConditionInput
  ) {
    updateValueAttribute(input: $input, condition: $condition) {
      id
      attributeId
      valueId
      value {
        id
        group
        name
        description
        organizationID
        companyId
        weight
        status
        createdAt
        updatedAt
      }
      companyId
      group
      attribute {
        id
        name
        definition
        stage
        customerDefinition
        align
        nonAlign
        createdAt
        updatedAt
      }
      weight
      order
      createdAt
      updatedAt
    }
  }
`;
export const deleteValueAttribute = /* GraphQL */ `
  mutation DeleteValueAttribute(
    $input: DeleteValueAttributeInput!
    $condition: ModelValueAttributeConditionInput
  ) {
    deleteValueAttribute(input: $input, condition: $condition) {
      id
      attributeId
      valueId
      value {
        id
        group
        name
        description
        organizationID
        companyId
        weight
        status
        createdAt
        updatedAt
      }
      companyId
      group
      attribute {
        id
        name
        definition
        stage
        customerDefinition
        align
        nonAlign
        createdAt
        updatedAt
      }
      weight
      order
      createdAt
      updatedAt
    }
  }
`;
export const createOrganization = /* GraphQL */ `
  mutation CreateOrganization(
    $input: CreateOrganizationInput!
    $condition: ModelOrganizationConditionInput
  ) {
    createOrganization(input: $input, condition: $condition) {
      id
      group
      name
      isPublished
      companyID
      organizationData
      values {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateOrganization = /* GraphQL */ `
  mutation UpdateOrganization(
    $input: UpdateOrganizationInput!
    $condition: ModelOrganizationConditionInput
  ) {
    updateOrganization(input: $input, condition: $condition) {
      id
      group
      name
      isPublished
      companyID
      organizationData
      values {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteOrganization = /* GraphQL */ `
  mutation DeleteOrganization(
    $input: DeleteOrganizationInput!
    $condition: ModelOrganizationConditionInput
  ) {
    deleteOrganization(input: $input, condition: $condition) {
      id
      group
      name
      isPublished
      companyID
      organizationData
      values {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      group
      firstName
      lastName
      title
      companyID
      email
      phone
      status
      role
      hasLoggedIn
      lastLoggedIn
      createdAt
      updatedAt
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      group
      firstName
      lastName
      title
      companyID
      email
      phone
      status
      role
      hasLoggedIn
      lastLoggedIn
      createdAt
      updatedAt
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      group
      firstName
      lastName
      title
      companyID
      email
      phone
      status
      role
      hasLoggedIn
      lastLoggedIn
      createdAt
      updatedAt
    }
  }
`;
export const createRole = /* GraphQL */ `
  mutation CreateRole(
    $input: CreateRoleInput!
    $condition: ModelRoleConditionInput
  ) {
    createRole(input: $input, condition: $condition) {
      id
      group
      name
      workingSession
      companyID
      createdAt
      updatedAt
    }
  }
`;
export const updateRole = /* GraphQL */ `
  mutation UpdateRole(
    $input: UpdateRoleInput!
    $condition: ModelRoleConditionInput
  ) {
    updateRole(input: $input, condition: $condition) {
      id
      group
      name
      workingSession
      companyID
      createdAt
      updatedAt
    }
  }
`;
export const deleteRole = /* GraphQL */ `
  mutation DeleteRole(
    $input: DeleteRoleInput!
    $condition: ModelRoleConditionInput
  ) {
    deleteRole(input: $input, condition: $condition) {
      id
      group
      name
      workingSession
      companyID
      createdAt
      updatedAt
    }
  }
`;
export const createJobRole = /* GraphQL */ `
  mutation CreateJobRole(
    $input: CreateJobRoleInput!
    $condition: ModelJobRoleConditionInput
  ) {
    createJobRole(input: $input, condition: $condition) {
      id
      group
      status
      jobRoleData
      exercise
      emailTemplate
      workingSession
      companyID
      createdAt
      updatedAt
    }
  }
`;
export const updateJobRole = /* GraphQL */ `
  mutation UpdateJobRole(
    $input: UpdateJobRoleInput!
    $condition: ModelJobRoleConditionInput
  ) {
    updateJobRole(input: $input, condition: $condition) {
      id
      group
      status
      jobRoleData
      exercise
      emailTemplate
      workingSession
      companyID
      createdAt
      updatedAt
    }
  }
`;
export const deleteJobRole = /* GraphQL */ `
  mutation DeleteJobRole(
    $input: DeleteJobRoleInput!
    $condition: ModelJobRoleConditionInput
  ) {
    deleteJobRole(input: $input, condition: $condition) {
      id
      group
      status
      jobRoleData
      exercise
      emailTemplate
      workingSession
      companyID
      createdAt
      updatedAt
    }
  }
`;
export const createReview = /* GraphQL */ `
  mutation CreateReview(
    $input: CreateReviewInput!
    $condition: ModelReviewConditionInput
  ) {
    createReview(input: $input, condition: $condition) {
      id
      interviewId
      author
      notes
      createdAt
      updatedAt
    }
  }
`;
export const updateReview = /* GraphQL */ `
  mutation UpdateReview(
    $input: UpdateReviewInput!
    $condition: ModelReviewConditionInput
  ) {
    updateReview(input: $input, condition: $condition) {
      id
      interviewId
      author
      notes
      createdAt
      updatedAt
    }
  }
`;
export const deleteReview = /* GraphQL */ `
  mutation DeleteReview(
    $input: DeleteReviewInput!
    $condition: ModelReviewConditionInput
  ) {
    deleteReview(input: $input, condition: $condition) {
      id
      interviewId
      author
      notes
      createdAt
      updatedAt
    }
  }
`;
export const createQuestionResponse = /* GraphQL */ `
  mutation CreateQuestionResponse(
    $input: CreateQuestionResponseInput!
    $condition: ModelQuestionResponseConditionInput
  ) {
    createQuestionResponse(input: $input, condition: $condition) {
      id
      interviewId
      stage
      rating
      timestamp
      interviewerName
      question
      notes
      order
      attribute
      attributeResolved
      ai_score
      ai_reasoning
      ai_quotes
      subquestionResponses {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateQuestionResponse = /* GraphQL */ `
  mutation UpdateQuestionResponse(
    $input: UpdateQuestionResponseInput!
    $condition: ModelQuestionResponseConditionInput
  ) {
    updateQuestionResponse(input: $input, condition: $condition) {
      id
      interviewId
      stage
      rating
      timestamp
      interviewerName
      question
      notes
      order
      attribute
      attributeResolved
      ai_score
      ai_reasoning
      ai_quotes
      subquestionResponses {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteQuestionResponse = /* GraphQL */ `
  mutation DeleteQuestionResponse(
    $input: DeleteQuestionResponseInput!
    $condition: ModelQuestionResponseConditionInput
  ) {
    deleteQuestionResponse(input: $input, condition: $condition) {
      id
      interviewId
      stage
      rating
      timestamp
      interviewerName
      question
      notes
      order
      attribute
      attributeResolved
      ai_score
      ai_reasoning
      ai_quotes
      subquestionResponses {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createAiQuestionResponseArchive = /* GraphQL */ `
  mutation CreateAiQuestionResponseArchive(
    $input: CreateAIQuestionResponseArchiveInput!
    $condition: ModelAIQuestionResponseArchiveConditionInput
  ) {
    createAIQuestionResponseArchive(input: $input, condition: $condition) {
      id
      original_id
      rick_score
      interviewId
      stage
      rating
      timestamp
      interviewerName
      question
      notes
      order
      attribute
      attributeResolved
      ai_score
      ai_reasoning
      ai_quotes
      createdAt
      updatedAt
    }
  }
`;
export const updateAiQuestionResponseArchive = /* GraphQL */ `
  mutation UpdateAiQuestionResponseArchive(
    $input: UpdateAIQuestionResponseArchiveInput!
    $condition: ModelAIQuestionResponseArchiveConditionInput
  ) {
    updateAIQuestionResponseArchive(input: $input, condition: $condition) {
      id
      original_id
      rick_score
      interviewId
      stage
      rating
      timestamp
      interviewerName
      question
      notes
      order
      attribute
      attributeResolved
      ai_score
      ai_reasoning
      ai_quotes
      createdAt
      updatedAt
    }
  }
`;
export const deleteAiQuestionResponseArchive = /* GraphQL */ `
  mutation DeleteAiQuestionResponseArchive(
    $input: DeleteAIQuestionResponseArchiveInput!
    $condition: ModelAIQuestionResponseArchiveConditionInput
  ) {
    deleteAIQuestionResponseArchive(input: $input, condition: $condition) {
      id
      original_id
      rick_score
      interviewId
      stage
      rating
      timestamp
      interviewerName
      question
      notes
      order
      attribute
      attributeResolved
      ai_score
      ai_reasoning
      ai_quotes
      createdAt
      updatedAt
    }
  }
`;
export const createSubquestionResponse = /* GraphQL */ `
  mutation CreateSubquestionResponse(
    $input: CreateSubquestionResponseInput!
    $condition: ModelSubquestionResponseConditionInput
  ) {
    createSubquestionResponse(input: $input, condition: $condition) {
      id
      questionResponseId
      question
      notes
      order
      displayTime
      createdAt
      updatedAt
    }
  }
`;
export const updateSubquestionResponse = /* GraphQL */ `
  mutation UpdateSubquestionResponse(
    $input: UpdateSubquestionResponseInput!
    $condition: ModelSubquestionResponseConditionInput
  ) {
    updateSubquestionResponse(input: $input, condition: $condition) {
      id
      questionResponseId
      question
      notes
      order
      displayTime
      createdAt
      updatedAt
    }
  }
`;
export const deleteSubquestionResponse = /* GraphQL */ `
  mutation DeleteSubquestionResponse(
    $input: DeleteSubquestionResponseInput!
    $condition: ModelSubquestionResponseConditionInput
  ) {
    deleteSubquestionResponse(input: $input, condition: $condition) {
      id
      questionResponseId
      question
      notes
      order
      displayTime
      createdAt
      updatedAt
    }
  }
`;
export const createRecording = /* GraphQL */ `
  mutation CreateRecording(
    $input: CreateRecordingInput!
    $condition: ModelRecordingConditionInput
  ) {
    createRecording(input: $input, condition: $condition) {
      id
      interviewId
      stage
      path
      createdAt
      updatedAt
    }
  }
`;
export const updateRecording = /* GraphQL */ `
  mutation UpdateRecording(
    $input: UpdateRecordingInput!
    $condition: ModelRecordingConditionInput
  ) {
    updateRecording(input: $input, condition: $condition) {
      id
      interviewId
      stage
      path
      createdAt
      updatedAt
    }
  }
`;
export const deleteRecording = /* GraphQL */ `
  mutation DeleteRecording(
    $input: DeleteRecordingInput!
    $condition: ModelRecordingConditionInput
  ) {
    deleteRecording(input: $input, condition: $condition) {
      id
      interviewId
      stage
      path
      createdAt
      updatedAt
    }
  }
`;
export const createMeeting = /* GraphQL */ `
  mutation CreateMeeting(
    $input: CreateMeetingInput!
    $condition: ModelMeetingConditionInput
  ) {
    createMeeting(input: $input, condition: $condition) {
      id
      interviewId
      stage
      startTime
      endTime
      audioUrl
      files {
        interviewerTranscriptUrl
        interviewerAudioUrl
        intervieweeTranscriptUrl
        intervieweeAudioUrl
      }
      analysis {
        id
        timestamp
        ml_version
        createdAt
        updatedAt
      }
      ai_conclusion_next_stage
      ai_conclusion_reasoning
      ai_conclusion_fit
      ai_conclusion_strong
      ai_conclusion_weak
      ai_agg_score
      ai_confidence
      createdAt
      updatedAt
      meetingAnalysisId
    }
  }
`;
export const updateMeeting = /* GraphQL */ `
  mutation UpdateMeeting(
    $input: UpdateMeetingInput!
    $condition: ModelMeetingConditionInput
  ) {
    updateMeeting(input: $input, condition: $condition) {
      id
      interviewId
      stage
      startTime
      endTime
      audioUrl
      files {
        interviewerTranscriptUrl
        interviewerAudioUrl
        intervieweeTranscriptUrl
        intervieweeAudioUrl
      }
      analysis {
        id
        timestamp
        ml_version
        createdAt
        updatedAt
      }
      ai_conclusion_next_stage
      ai_conclusion_reasoning
      ai_conclusion_fit
      ai_conclusion_strong
      ai_conclusion_weak
      ai_agg_score
      ai_confidence
      createdAt
      updatedAt
      meetingAnalysisId
    }
  }
`;
export const deleteMeeting = /* GraphQL */ `
  mutation DeleteMeeting(
    $input: DeleteMeetingInput!
    $condition: ModelMeetingConditionInput
  ) {
    deleteMeeting(input: $input, condition: $condition) {
      id
      interviewId
      stage
      startTime
      endTime
      audioUrl
      files {
        interviewerTranscriptUrl
        interviewerAudioUrl
        intervieweeTranscriptUrl
        intervieweeAudioUrl
      }
      analysis {
        id
        timestamp
        ml_version
        createdAt
        updatedAt
      }
      ai_conclusion_next_stage
      ai_conclusion_reasoning
      ai_conclusion_fit
      ai_conclusion_strong
      ai_conclusion_weak
      ai_agg_score
      ai_confidence
      createdAt
      updatedAt
      meetingAnalysisId
    }
  }
`;
export const createQuestion = /* GraphQL */ `
  mutation CreateQuestion(
    $input: CreateQuestionInput!
    $condition: ModelQuestionConditionInput
  ) {
    createQuestion(input: $input, condition: $condition) {
      id
      stage
      companyID
      attributes {
        nextToken
      }
      isActive
      text
      interactionType
      order
      required
      createdAt
      updatedAt
      isPrivate
    }
  }
`;
export const updateQuestion = /* GraphQL */ `
  mutation UpdateQuestion(
    $input: UpdateQuestionInput!
    $condition: ModelQuestionConditionInput
  ) {
    updateQuestion(input: $input, condition: $condition) {
      id
      stage
      companyID
      attributes {
        nextToken
      }
      isActive
      text
      interactionType
      order
      required
      createdAt
      updatedAt
      isPrivate
    }
  }
`;
export const deleteQuestion = /* GraphQL */ `
  mutation DeleteQuestion(
    $input: DeleteQuestionInput!
    $condition: ModelQuestionConditionInput
  ) {
    deleteQuestion(input: $input, condition: $condition) {
      id
      stage
      companyID
      attributes {
        nextToken
      }
      isActive
      text
      interactionType
      order
      required
      createdAt
      updatedAt
      isPrivate
    }
  }
`;
export const createCompanyQuestions = /* GraphQL */ `
  mutation CreateCompanyQuestions(
    $input: CreateCompanyQuestionsInput!
    $condition: ModelCompanyQuestionsConditionInput
  ) {
    createCompanyQuestions(input: $input, condition: $condition) {
      companyID
      questions {
        nextToken
      }
      createdAt
      updatedAt
      id
    }
  }
`;
export const updateCompanyQuestions = /* GraphQL */ `
  mutation UpdateCompanyQuestions(
    $input: UpdateCompanyQuestionsInput!
    $condition: ModelCompanyQuestionsConditionInput
  ) {
    updateCompanyQuestions(input: $input, condition: $condition) {
      companyID
      questions {
        nextToken
      }
      createdAt
      updatedAt
      id
    }
  }
`;
export const deleteCompanyQuestions = /* GraphQL */ `
  mutation DeleteCompanyQuestions(
    $input: DeleteCompanyQuestionsInput!
    $condition: ModelCompanyQuestionsConditionInput
  ) {
    deleteCompanyQuestions(input: $input, condition: $condition) {
      companyID
      questions {
        nextToken
      }
      createdAt
      updatedAt
      id
    }
  }
`;
export const createSubQuestions = /* GraphQL */ `
  mutation CreateSubQuestions(
    $input: CreateSubQuestionsInput!
    $condition: ModelSubQuestionsConditionInput
  ) {
    createSubQuestions(input: $input, condition: $condition) {
      id
      questionID
      isActive
      text
      createdAt
      updatedAt
    }
  }
`;
export const updateSubQuestions = /* GraphQL */ `
  mutation UpdateSubQuestions(
    $input: UpdateSubQuestionsInput!
    $condition: ModelSubQuestionsConditionInput
  ) {
    updateSubQuestions(input: $input, condition: $condition) {
      id
      questionID
      isActive
      text
      createdAt
      updatedAt
    }
  }
`;
export const deleteSubQuestions = /* GraphQL */ `
  mutation DeleteSubQuestions(
    $input: DeleteSubQuestionsInput!
    $condition: ModelSubQuestionsConditionInput
  ) {
    deleteSubQuestions(input: $input, condition: $condition) {
      id
      questionID
      isActive
      text
      createdAt
      updatedAt
    }
  }
`;
export const createAnalysis = /* GraphQL */ `
  mutation CreateAnalysis(
    $input: CreateAnalysisInput!
    $condition: ModelAnalysisConditionInput
  ) {
    createAnalysis(input: $input, condition: $condition) {
      id
      timestamp
      ml_version
      attributeAnalyses {
        nextToken
      }
      questionAnalyses {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateAnalysis = /* GraphQL */ `
  mutation UpdateAnalysis(
    $input: UpdateAnalysisInput!
    $condition: ModelAnalysisConditionInput
  ) {
    updateAnalysis(input: $input, condition: $condition) {
      id
      timestamp
      ml_version
      attributeAnalyses {
        nextToken
      }
      questionAnalyses {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteAnalysis = /* GraphQL */ `
  mutation DeleteAnalysis(
    $input: DeleteAnalysisInput!
    $condition: ModelAnalysisConditionInput
  ) {
    deleteAnalysis(input: $input, condition: $condition) {
      id
      timestamp
      ml_version
      attributeAnalyses {
        nextToken
      }
      questionAnalyses {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createAttributeAnalysis = /* GraphQL */ `
  mutation CreateAttributeAnalysis(
    $input: CreateAttributeAnalysisInput!
    $condition: ModelAttributeAnalysisConditionInput
  ) {
    createAttributeAnalysis(input: $input, condition: $condition) {
      id
      isLatest
      attribute {
        id
        companyID
        group
        title
        description
        weight
        createdAt
        updatedAt
      }
      questionAnalyses {
        nextToken
      }
      createdAt
      updatedAt
      analysisAttributeAnalysesId
      attributeAnalysisAttributeId
    }
  }
`;
export const updateAttributeAnalysis = /* GraphQL */ `
  mutation UpdateAttributeAnalysis(
    $input: UpdateAttributeAnalysisInput!
    $condition: ModelAttributeAnalysisConditionInput
  ) {
    updateAttributeAnalysis(input: $input, condition: $condition) {
      id
      isLatest
      attribute {
        id
        companyID
        group
        title
        description
        weight
        createdAt
        updatedAt
      }
      questionAnalyses {
        nextToken
      }
      createdAt
      updatedAt
      analysisAttributeAnalysesId
      attributeAnalysisAttributeId
    }
  }
`;
export const deleteAttributeAnalysis = /* GraphQL */ `
  mutation DeleteAttributeAnalysis(
    $input: DeleteAttributeAnalysisInput!
    $condition: ModelAttributeAnalysisConditionInput
  ) {
    deleteAttributeAnalysis(input: $input, condition: $condition) {
      id
      isLatest
      attribute {
        id
        companyID
        group
        title
        description
        weight
        createdAt
        updatedAt
      }
      questionAnalyses {
        nextToken
      }
      createdAt
      updatedAt
      analysisAttributeAnalysesId
      attributeAnalysisAttributeId
    }
  }
`;
export const createAttributeDefinitions = /* GraphQL */ `
  mutation CreateAttributeDefinitions(
    $input: CreateAttributeDefinitionsInput!
    $condition: ModelAttributeDefinitionsConditionInput
  ) {
    createAttributeDefinitions(input: $input, condition: $condition) {
      id
      name
      definition
      stage
      customerDefinition
      align
      nonAlign
      createdAt
      updatedAt
    }
  }
`;
export const updateAttributeDefinitions = /* GraphQL */ `
  mutation UpdateAttributeDefinitions(
    $input: UpdateAttributeDefinitionsInput!
    $condition: ModelAttributeDefinitionsConditionInput
  ) {
    updateAttributeDefinitions(input: $input, condition: $condition) {
      id
      name
      definition
      stage
      customerDefinition
      align
      nonAlign
      createdAt
      updatedAt
    }
  }
`;
export const deleteAttributeDefinitions = /* GraphQL */ `
  mutation DeleteAttributeDefinitions(
    $input: DeleteAttributeDefinitionsInput!
    $condition: ModelAttributeDefinitionsConditionInput
  ) {
    deleteAttributeDefinitions(input: $input, condition: $condition) {
      id
      name
      definition
      stage
      customerDefinition
      align
      nonAlign
      createdAt
      updatedAt
    }
  }
`;
export const createQuestionAttributeAnalysis = /* GraphQL */ `
  mutation CreateQuestionAttributeAnalysis(
    $input: CreateQuestionAttributeAnalysisInput!
    $condition: ModelQuestionAttributeAnalysisConditionInput
  ) {
    createQuestionAttributeAnalysis(input: $input, condition: $condition) {
      question {
        id
        stage
        companyID
        isActive
        text
        interactionType
        order
        required
        createdAt
        updatedAt
        isPrivate
      }
      score
      reasoning
      quotes {
        start
        end
        sentence
      }
      createdAt
      updatedAt
      id
      attributeAnalysisQuestionAnalysesId
      questionAttributeAnalysisQuestionId
    }
  }
`;
export const updateQuestionAttributeAnalysis = /* GraphQL */ `
  mutation UpdateQuestionAttributeAnalysis(
    $input: UpdateQuestionAttributeAnalysisInput!
    $condition: ModelQuestionAttributeAnalysisConditionInput
  ) {
    updateQuestionAttributeAnalysis(input: $input, condition: $condition) {
      question {
        id
        stage
        companyID
        isActive
        text
        interactionType
        order
        required
        createdAt
        updatedAt
        isPrivate
      }
      score
      reasoning
      quotes {
        start
        end
        sentence
      }
      createdAt
      updatedAt
      id
      attributeAnalysisQuestionAnalysesId
      questionAttributeAnalysisQuestionId
    }
  }
`;
export const deleteQuestionAttributeAnalysis = /* GraphQL */ `
  mutation DeleteQuestionAttributeAnalysis(
    $input: DeleteQuestionAttributeAnalysisInput!
    $condition: ModelQuestionAttributeAnalysisConditionInput
  ) {
    deleteQuestionAttributeAnalysis(input: $input, condition: $condition) {
      question {
        id
        stage
        companyID
        isActive
        text
        interactionType
        order
        required
        createdAt
        updatedAt
        isPrivate
      }
      score
      reasoning
      quotes {
        start
        end
        sentence
      }
      createdAt
      updatedAt
      id
      attributeAnalysisQuestionAnalysesId
      questionAttributeAnalysisQuestionId
    }
  }
`;
export const createQuestionDiscoveryAnalysis = /* GraphQL */ `
  mutation CreateQuestionDiscoveryAnalysis(
    $input: CreateQuestionDiscoveryAnalysisInput!
    $condition: ModelQuestionDiscoveryAnalysisConditionInput
  ) {
    createQuestionDiscoveryAnalysis(input: $input, condition: $condition) {
      question {
        id
        stage
        companyID
        isActive
        text
        interactionType
        order
        required
        createdAt
        updatedAt
        isPrivate
      }
      score
      reasoning
      quotes {
        start
        end
        sentence
      }
      createdAt
      updatedAt
      id
      analysisQuestionAnalysesId
      questionDiscoveryAnalysisQuestionId
    }
  }
`;
export const updateQuestionDiscoveryAnalysis = /* GraphQL */ `
  mutation UpdateQuestionDiscoveryAnalysis(
    $input: UpdateQuestionDiscoveryAnalysisInput!
    $condition: ModelQuestionDiscoveryAnalysisConditionInput
  ) {
    updateQuestionDiscoveryAnalysis(input: $input, condition: $condition) {
      question {
        id
        stage
        companyID
        isActive
        text
        interactionType
        order
        required
        createdAt
        updatedAt
        isPrivate
      }
      score
      reasoning
      quotes {
        start
        end
        sentence
      }
      createdAt
      updatedAt
      id
      analysisQuestionAnalysesId
      questionDiscoveryAnalysisQuestionId
    }
  }
`;
export const deleteQuestionDiscoveryAnalysis = /* GraphQL */ `
  mutation DeleteQuestionDiscoveryAnalysis(
    $input: DeleteQuestionDiscoveryAnalysisInput!
    $condition: ModelQuestionDiscoveryAnalysisConditionInput
  ) {
    deleteQuestionDiscoveryAnalysis(input: $input, condition: $condition) {
      question {
        id
        stage
        companyID
        isActive
        text
        interactionType
        order
        required
        createdAt
        updatedAt
        isPrivate
      }
      score
      reasoning
      quotes {
        start
        end
        sentence
      }
      createdAt
      updatedAt
      id
      analysisQuestionAnalysesId
      questionDiscoveryAnalysisQuestionId
    }
  }
`;
export const createWorkingSessionExercise = /* GraphQL */ `
  mutation CreateWorkingSessionExercise(
    $input: CreateWorkingSessionExerciseInput!
    $condition: ModelWorkingSessionExerciseConditionInput
  ) {
    createWorkingSessionExercise(input: $input, condition: $condition) {
      id
      role {
        id
        group
        name
        workingSession
        companyID
        createdAt
        updatedAt
      }
      companyId
      exercise
      question1
      question2
      question3
      question4
      question5
      createdAt
      updatedAt
      workingSessionExerciseRoleId
    }
  }
`;
export const updateWorkingSessionExercise = /* GraphQL */ `
  mutation UpdateWorkingSessionExercise(
    $input: UpdateWorkingSessionExerciseInput!
    $condition: ModelWorkingSessionExerciseConditionInput
  ) {
    updateWorkingSessionExercise(input: $input, condition: $condition) {
      id
      role {
        id
        group
        name
        workingSession
        companyID
        createdAt
        updatedAt
      }
      companyId
      exercise
      question1
      question2
      question3
      question4
      question5
      createdAt
      updatedAt
      workingSessionExerciseRoleId
    }
  }
`;
export const deleteWorkingSessionExercise = /* GraphQL */ `
  mutation DeleteWorkingSessionExercise(
    $input: DeleteWorkingSessionExerciseInput!
    $condition: ModelWorkingSessionExerciseConditionInput
  ) {
    deleteWorkingSessionExercise(input: $input, condition: $condition) {
      id
      role {
        id
        group
        name
        workingSession
        companyID
        createdAt
        updatedAt
      }
      companyId
      exercise
      question1
      question2
      question3
      question4
      question5
      createdAt
      updatedAt
      workingSessionExerciseRoleId
    }
  }
`;
export const createAttributeQuestions = /* GraphQL */ `
  mutation CreateAttributeQuestions(
    $input: CreateAttributeQuestionsInput!
    $condition: ModelAttributeQuestionsConditionInput
  ) {
    createAttributeQuestions(input: $input, condition: $condition) {
      id
      attributeID
      questionID
      attribute {
        id
        companyID
        group
        title
        description
        weight
        createdAt
        updatedAt
      }
      question {
        id
        stage
        companyID
        isActive
        text
        interactionType
        order
        required
        createdAt
        updatedAt
        isPrivate
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateAttributeQuestions = /* GraphQL */ `
  mutation UpdateAttributeQuestions(
    $input: UpdateAttributeQuestionsInput!
    $condition: ModelAttributeQuestionsConditionInput
  ) {
    updateAttributeQuestions(input: $input, condition: $condition) {
      id
      attributeID
      questionID
      attribute {
        id
        companyID
        group
        title
        description
        weight
        createdAt
        updatedAt
      }
      question {
        id
        stage
        companyID
        isActive
        text
        interactionType
        order
        required
        createdAt
        updatedAt
        isPrivate
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteAttributeQuestions = /* GraphQL */ `
  mutation DeleteAttributeQuestions(
    $input: DeleteAttributeQuestionsInput!
    $condition: ModelAttributeQuestionsConditionInput
  ) {
    deleteAttributeQuestions(input: $input, condition: $condition) {
      id
      attributeID
      questionID
      attribute {
        id
        companyID
        group
        title
        description
        weight
        createdAt
        updatedAt
      }
      question {
        id
        stage
        companyID
        isActive
        text
        interactionType
        order
        required
        createdAt
        updatedAt
        isPrivate
      }
      createdAt
      updatedAt
    }
  }
`;
